export default ({...props}) => {
  const {palette, space} = props.theme
  return `
        background-color: ${palette.primary.main};
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: ${space(0)}px;
        z-index: 1;
        & p{
          margin: 0px;
        }
        & img,
        & a {
          display: flex;
        }
`
}
